import { Fragment } from 'react';
import { mediaQurey, zIndex } from 'helper/Style';
import Head from 'component/part/Head';
import Header from 'component/part/Header';
import Menu from 'component/part/Menu';

export type LayoutProps = Readonly<{
  children: React.JSX.Element | React.JSX.Element[];
}>;

const style = {
  layout: {
    width: '100vw',
    fontSize: '1.6rem',
  },
  header: {
    position: 'sticky' as const,
    top: '0',
    width: '100%',
    height: '3.6rem',
    zIndex: zIndex.header,
  },
  content: {
    position: 'relative' as const,
    display: 'flex',
    width: '100%',
    [mediaQurey('max', 'sp')]: {
      display: 'initial',
    },
  },
  menuArea: {
    backgroundColor: '#ffffff',
    zIndex: zIndex.menu,
    [mediaQurey('min', 'pc')]: {
      position: 'sticky' as const,
      top: '3.6rem',
      height: 'calc(100vh - 3.6rem)',
      minHeight: 'fit-content',
    },
    [mediaQurey('max', 'tablet')]: {
      position: 'fixed' as const,
      top: '3.6rem',
      left: '0',
      height: '100%',
    },
  },
  mainArea: {
    flexGrow: '1',
    overflowX: 'hidden' as const,
    padding: '2rem 4rem',
  },
};

const Layout = (props: LayoutProps) =>
  <Fragment>
    <Head />
    <div css={style.layout}>
      <Header css={style.header} />
      <div css={style.content}>
        <Menu css={style.menuArea} />
        <div css={style.mainArea}>
          {props.children}
        </div>
      </div>
    </div>
  </Fragment>;

export default Layout;
